<template>
  <v-row justify="center" align="start">
    <v-col cols="12">
      <v-banner icon="check_circle_outline">
        Template Confirmed
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>
    <v-col cols="12">
      <TemplateProgress :step="3"></TemplateProgress>
    </v-col>

    <v-col cols="12" lg="8">
      <v-card outlined shaped>
        <v-card-title>
          <v-icon class="mr-2">info</v-icon>How It Works
        </v-card-title>
        <v-card-text>Now you've populated your template you can select the trolly from the search screen when adding products to your order.</v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" lg="8">
      <v-btn
        @click="OrderHereRedirect()"
        color="primary"
        class="white--text"
        block
        x-large
      >Order Here</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

import TemplateProgress from "@/components/order/template/TemplateProgress.vue";

export default {
  components: {
    TemplateProgress
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    }
  },

  methods: {
    ...mapActions(["setSelectedTrolly", "cloneTrolly"]),

    OrderHereRedirect() {
      if (this.trolly) {
        this.$router.push({ name: "OrdersSearch" });
        return;
      } else if (this.$store.getters.retrieveHasMultipleTrollys) {
        //Push Search first because when we go back from selecting a basket we want to be on the search page
        this.$router.push({ name: "OrdersSearch" });
        this.$router.push({ name: "OrdersBasketSelection" });
        return;
      } else {
        this.$router.push({ name: "OrdersCreate" });
        return;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
</style>